import React, { useEffect, lazy, Suspense } from "react";
import FAQTeaser from "@/components/home/FAQTeaser";
import { captureAttribution } from "@/lib/homeAttribution";
import SEO from "../components/SEO";
import BreadcrumbSchema from "../components/BreadcrumbSchema";
import { SEO_STRATEGY } from "../lib/seoConfig";
import AnnouncementBar from "@/components/site/AnnouncementBar";
import HomeHero from "@/components/site/HomeHero";
import FeatureCards from "@/components/site/FeatureCards";
import HowItWorks from "@/components/site/HowItWorks";
import WhoItsFor from "@/components/site/WhoItsFor";
import IsIsNotGrid from "@/components/site/IsIsNotGrid";
import CtaBanner from "@/components/site/CtaBanner";

const AudienceSegmentSection = lazy(() => import("@/components/home/AudienceSegmentSection"));
const SolutionOverviewSection = lazy(() => import("@/components/home/SolutionOverviewSection"));
const OfferLadderSection = lazy(() => import("@/components/home/OfferLadderSection"));
const TrustProofSection = lazy(() => import("@/components/home/TrustProofSection"));

export default function Home() {
  useEffect(() => { captureAttribution(); }, []);
  return (
    <div className="pt-[60px]">
      <SEO
        title="CLIA & CAP Lab Compliance Consulting | LabComplyx"
        description="Governed AI-assisted documentation for CLIA- and CAP-regulated labs: CAPA, deviations, SOP control, and inspection readiness. Every output requires human review."
        keywords="CLIA compliance consulting, CAP inspection readiness, CLIA gap audit, regulated lab compliance, clinical lab documentation, CAPA documentation, SOP management, inspection readiness"
        canonical="https://labcomplyx.com/"
        ogUrl="https://labcomplyx.com/"
        breadcrumbs={SEO_STRATEGY.pageMetadata['/']?.breadcrumbs}
      />
      <BreadcrumbSchema breadcrumbs={SEO_STRATEGY.pageMetadata['/']?.breadcrumbs} />
      <AnnouncementBar />
      <HomeHero />
      <FeatureCards />
      <HowItWorks />
      <WhoItsFor />
      <IsIsNotGrid />
      <Suspense fallback={null}>
        <AudienceSegmentSection />
        <SolutionOverviewSection />
        <OfferLadderSection />
        <TrustProofSection />
      </Suspense>
      <FAQTeaser />
      <CtaBanner
        title="Start with the free Lab Health Score — 15 minutes."
        sub="Gap report across 10 compliance domains. No sales call, no obligation."
        healthLabel="Get My Health Score →"
      />
    </div>
  );
}